module.exports = __webpack_public_path__ + "statics/img/01.b1547b28.png";